/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function MediaAcceptProfilesGeneralValidatorEditViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    uiGridConstants: JS5Object,
    MediaAcceptProfileService: JS5Object,
) {
    this.editData = {
        trackNumber: null
    };

    this.onTruncatedChanged = () => {
        switch (_.toLower(this.truncated)) {
            case 'required':
                this.editData.truncated = 'true';
                break;
            case 'forbidden':
                this.editData.truncated = 'false';
                break;
            default:
                this.editData.truncated = null;
        }
    }

    this.validateInteger = (value: number) => {
        return _.isInteger(value) && _.toNumber(value) > -1;
    };

    const setValidator = (validators: Array<JS5Object>) => {
        this.validators = validators;
        let validator: JS5Object = _.first(_.remove(validators, <JS5Object>{validatorType: 'GENERAL'}));
        if (!_.isNil(validator)) {
            this.editData = _.cloneDeep(validator);
            this.editData.trackNumber = _.toInteger(validator.trackNumber);
            this.originalTrackNumber = _.toInteger(validator.trackNumber);
        } else {
            this.originalTrackNumber = null;
        }
        MediaAcceptProfileService.originalGeneralValidatorEditData = _.cloneDeep(this.editData);
    };

    const getData = () => {
        this.loadingIndicator.show = true;
        MediaAcceptProfileService.getValidators($routeParams.id, false).then((validators: Array<JS5Object>) => {
            setValidator(validators);
        }).finally(() => {
            switch(this.editData.truncated) {
                case 'true':
                    this.truncated = 'Required';
                    break;
                case 'false':
                    this.truncated = 'Forbidden';
                    break;
                default:
                    this.truncated = 'Not Validated';
                    break;
            }
            this.loadingIndicator.show = false;
        });
    };

    const saveHandler = () => {
        this.loadingIndicator.show = true;
        this.editData.validatorType = 'GENERAL';
        let validatorsToSave = _.concat([this.editData], this.validators);
        MediaAcceptProfileService.updateValidators($routeParams.id, validatorsToSave).then((validators: Array<JS5Object>) => {
            setValidator(validators);
        }).finally(() => {
            this.loadingIndicator.show = false;
            this.editorForm.$setPristine();
            this.setFormPristine();
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine')
                && !_.isNil(_.get(this.editData, 'trackNumber'))
                && _.toNumber(_.get(this.editData, 'trackNumber')) > -1
                && _.isInteger(_.toNumber(_.get(this.editData, 'trackNumber'))),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(MediaAcceptProfileService.originalGeneralValidatorEditData);
                if (!_.isNil(MediaAcceptProfileService.originalGeneralValidatorEditData.trackNumber)) {
                    this.editData.trackNumber = _.toInteger(MediaAcceptProfileService.originalGeneralValidatorEditData.trackNumber);
                } else {
                    this.editData.trackNumber = null;
                }
                this.setFormPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => true,
            onClick: () => $location.url(`/system/templates/search`).search({
                tab: 'Media',
                subTab: 'MediaAcceptProfiles'
            })
        }
    ];


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.truncatedOptions = [ 'Required', 'Forbidden', 'Not Validated' ]
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();

    };

    this.$postLink = () => {
        $timeout(() => {
            MediaAcceptProfileService.editorForm = this.editorForm;
        });
    };

    this.$onDestroy = () => {
        MediaAcceptProfileService.editorForm = null;
    };
}


angular.module('prism-ui.mediaAcceptProfiles').component('mediaAcceptProfilesGeneralValidatorEditView', {
    templateUrl: 'system/templates/mediaAcceptProfiles/components/validators/general/editor/media-accept-profiles-general-validator-edit-view-template.html',
    controller: MediaAcceptProfilesGeneralValidatorEditViewController,
    bindings: {
        setFormPristine: '&',
        mediaAcceptProfile: '<'
    }
});
